import { defineMessages } from 'react-intl';

export const scope = 'app.containers.home';

export default defineMessages({
  home: {
    id: `${scope}.home`,
    defaultMessage: '',
  },
  ticket: {
    id: `${scope}.ticket`,
    defaultMessage: '',
  },
  myPocket: {
    id: `${scope}.myPocket`,
    defaultMessage: '',
  },
  discovery: {
    id: `${scope}.discovery`,
    defaultMessage: '',
  },
});
